import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import {
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';

import { getLocalDateFromDateString } from '../../helpers/helpers';
import i18n from '../../i18n';

class ModalTableOfEmployees extends Component {
  render() {
    const {
      label,
      employees,
      rowStyle
    } = this.props;
    if (employees && employees.length === 0) {
      return null;
    }
    return (
      <>
        <p>{i18n.t(`schedule:${label}`)}</p>
        <Table>
          <TableBody>
            {employees.map(employee => {
              const { id, name, email, bookedDate } = employee;
              return (
                <TableRow key={`${id}${bookedDate}`} className={rowStyle}>
                  <TableCell align="center">{name}</TableCell>
                  <TableCell align="center">{email}</TableCell>
                  <TableCell align="center">
                    {format(getLocalDateFromDateString(bookedDate), 'MMM d, yyyy')}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </>
    );
  }
}

ModalTableOfEmployees.defaultProps = {
  label: '',
  rowStyle: '',
};

ModalTableOfEmployees.propTypes = {
  employees: PropTypes.arrayOf(PropTypes.object).isRequired,
  label: PropTypes.string,
  rowStyle: PropTypes.string,
};

export default ModalTableOfEmployees;
